import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLegacyServices } from "../../services/legacy/legacyApi";


export const fetchLegacies = createAsyncThunk(
  "legacies/fetchLegacies",
  async (accessToken, { rejectWithValue }) => {
    try {
      const response = await getLegacyServices(accessToken);
      if (response.status === 200) {
        return response.data.data;
      }
      return rejectWithValue("Failed to fetch legacy data");
    } catch (error) {
      return rejectWithValue(
        error
      );
    }
  }
);

// Define initial state separately for better reusability
const initialState = {
  legaciesData: [],
  legacyLoading: false,
  error: null,
};

const legaciesSlice = createSlice({
  name: "legacies",
  initialState,
  reducers: {
    resetLegaciesState: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLegacies.pending, (state) => {
        state.legacyLoading = true;
        state.error = null;
      })
      .addCase(fetchLegacies.fulfilled, (state, { payload }) => {
        state.legaciesData = payload;
        state.legacyLoading = false;
      })
      .addCase(fetchLegacies.rejected, (state, { payload }) => {
        state.legacyLoading = false;
        state.error = payload;
      });
  },
});

export const { resetLegaciesState } = legaciesSlice.actions;
export default legaciesSlice.reducer;
